import { Injectable } from '@angular/core';
import { Observable, fromEvent } from 'rxjs';
import { map } from 'rxjs/operators';
import { WindowRef } from './window-ref';

const BREAKPOINTS: [ViewportBreakpoint, string][] = [
    ['large', '(min-width: 1232px)'],
    ['medium', '(min-width: 928px) and (max-width: 1231px)'],
    ['small', '(min-width: 624px) and (max-width: 928px)'],
    ['xsmall', '(max-width: 624px)']
];

@Injectable()
export class ViewportUtil {
    private windowChange$: Observable<Event>;

    constructor(private windowRef: WindowRef) {
        this.windowChange$ = fromEvent(windowRef.nativeWindow, 'resize');
    }

    get() {
        return this.matchBreakpoint();
    }

    change(): Observable<ViewportBreakpoint> {
        return this.windowChange$.pipe(map(_ => this.matchBreakpoint()));
    }

    private matchBreakpoint(): ViewportBreakpoint {
        const breakpoint = BREAKPOINTS
            .find(([_, mediaQuery]) => this.windowRef.nativeWindow.matchMedia(mediaQuery).matches);
        return breakpoint ? breakpoint[0] : undefined;
    }
}

export type ViewportBreakpoint = 'xsmall' | 'small' | 'medium' | 'large';
